import { ApprovalListItemController } from './approval-list-item.controller'

function approvalListItem () {
  return {
    restrict: 'E',
    scope: {
      approval: '<'
    },
    templateUrl: '/core/directives/approval-list-item/approval-list-item-directive.html?$$REVISION$$',
    controller: ApprovalListItemController
  }
}

export { approvalListItem }
